// Icons
import GiftIcon from "assets/icons/glory/burger_mybonuses.svg?react";
import TransactionsIcon from "assets/icons/glory/burger_transaction.svg?react";
import ProfileIcon from "assets/icons/person.svg?react";
import MyBonus from "assets/icons/bonuses.svg?react";
import Support from "assets/icons/glory/burger_chat.svg?react";
import Invite from "assets/icons/glory/burger_invite.svg?react";
import HistoryGamesIcon from "assets/icons/glory/history-games.svg?react";
import TransactionHistory from "assets/icons/transactions-history.svg?react";
import GameHistory from "assets/icons/game-history.svg?react";
// import GameHistory from "assets/icons/game-history.svg?react";
// import ProfileIcon from "assets/icons/glory/burger_account.svg?react";
// import Password from "assets/icons/glory/burger_password.svg?react";

// Url
import url from "url/index";
import {
  MOBILE_NAVIGATION_ENUMS,
  MOBILE_NAVIGATION_ITEM_TYPE,
} from "./mobileNavigation";

type PROFILE_NAVIGATION_ITEM_TYPE = {
  id: PROFILE_NAVIGATION_ENUMS;
  name: string;
  icon: JSX.Element;
  url: string;
  htmlId?: string;
};

export type AccountNavItemType = {
  id: ACCOUNT_NAVIGATION_ENUM;
  title: string;
  icon: JSX.Element;
  location: Partial<Location>;
};

export enum PROFILE_NAVIGATION_ENUMS {
  ACCOUNT,
  TRANSACTIONS,
  GAMES_HISTORY,
  ACHIEVMENTS,
  BONUS,
  NOTIFICATION,
  INVITE,
  SUPPORT,
}

export enum ACCOUNT_NAVIGATION_ENUM {
  PERSONAL_DATA,
  PASSWORD,
  INVITE,
}

export const PROFILE_NAVIGATION: PROFILE_NAVIGATION_ITEM_TYPE[] = [
  {
    id: PROFILE_NAVIGATION_ENUMS.ACCOUNT,
    name: "sidebar.auth.account.page",
    icon: <ProfileIcon />,
    url: url.routes.profile.index(),
  },
  {
    id: PROFILE_NAVIGATION_ENUMS.TRANSACTIONS,
    name: "sidebar.auth.account.history",
    icon: <TransactionsIcon />,
    url: url.routes.profile.transactionDetail("deposit"),
  },
  {
    id: PROFILE_NAVIGATION_ENUMS.GAMES_HISTORY,
    name: "sidebar.auth.game.history",
    icon: <HistoryGamesIcon />,
    url: url.routes.profile.gamesHistory(),
  },
  {
    id: PROFILE_NAVIGATION_ENUMS.BONUS,
    name: "sidebar.auth.account.bonus.page",
    icon: <GiftIcon />,
    url: url.routes.profile.bonus(),
    htmlId: "profile-nav-bonuses",
  },
  {
    id: PROFILE_NAVIGATION_ENUMS.INVITE,
    name: "profile.account.invite",
    icon: <Invite />,
    url: url.routes.profile.inviteFriend(),
  },
  {
    id: PROFILE_NAVIGATION_ENUMS.SUPPORT,
    name: "burger.menu.support",
    icon: <Support />,
    url: "",
  },
];

export const ACCOUNT_NAVIGATION: MOBILE_NAVIGATION_ITEM_TYPE[] = [
  {
    id: MOBILE_NAVIGATION_ENUMS.PERSONAL_DATA,
    icon: <ProfileIcon />,
    name: "profile.account.header",
    url: url.routes.profile.personalInfo(),
  },
  {
    id: MOBILE_NAVIGATION_ENUMS.GAMES_HISTORY,
    name: "sidebar.auth.game.history",
    icon: <GameHistory />,
    url: url.routes.profile.gamesHistory(),
  },
  {
    id: MOBILE_NAVIGATION_ENUMS.BONUS,
    name: "sidebar.auth.account.bonus.page",
    icon: <MyBonus />,
    url: url.routes.profile.bonus(),
  },
  {
    id: MOBILE_NAVIGATION_ENUMS.TRANSACTIONS_HISTORY,
    name: "sidebar.auth.account.history",
    icon: <TransactionHistory />,
    url: url.routes.profile.transactionDetail("deposit"),
  },
];
